var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"googleauth"},[_c('NavigationBar',{scopedSlots:_vm._u([{key:"left",fn:function(){return [(_vm.loggedIn)?_c('img',{staticClass:"back",attrs:{"src":require("../assets/icons/ic_16_back.svg"),"data-testid":"nav-back"},on:{"click":_vm.goBack}}):_c('div')]},proxy:true},{key:"center",fn:function(){return undefined},proxy:true}])}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p')])
}]

export { render, staticRenderFns }